import styled from 'styled-components'
import { Button, Heading, Text, LogoIcon, LogoImg } from '@pancakeswap/uikit'
import Page from 'components/Layout/Page'
import { useTranslation } from '@pancakeswap/localization'
import Link from 'next/link'
import { logoConfig } from 'components/Menu/config/config'

const StyledNotFound = styled.div`
  align-items: center;
  display: flex;
  flex-direction: column;
  height: calc(100vh - 64px);
  justify-content: center;
`

const NotFound = ({ statusCode = 404 }: { statusCode?: number }) => {
  const { t } = useTranslation()

  return (
    <Page>
      <StyledNotFound>
        <LogoImg src={logoConfig.logoSrc} />
        <Heading scale="xxl">{statusCode}</Heading>
        <Text mb="16px">{t('Oops, page not found.')}</Text>
        <Link href="/swap" passHref>
          <Button as="a" scale="sm">
            {t('Back Swap')}
          </Button>
        </Link>
      </StyledNotFound>
    </Page>
  )
}

export default NotFound
